import BasicLayout from './basicLayout';
import { IData, IOptions } from './interface';
import renderSentryReportWithVersion from './partial/sentry';
import titlePart from './partial/title';
import metaPart from './partial/meta';
import bootPart from './partial/boot';
import monitorPart from './partial/monitor';
import es6ShimPart from './partial/es6Shim';

class StaticPageLayout<T extends IData = IData, K extends IOptions = IOptions> extends BasicLayout<T, K> {
    constructor(data: T, options: K) {
        super(data, options);
    }

    public renderTitle() {
        return titlePart();
    }

    public renderMeta() {
        return metaPart();
    }

    public renderHeaderCss() {
        let cssPart = '{{source.globalCss | default("") | safe}}\n';
        this.options.css.forEach((path: string) => {
            cssPart += `<link href="${path}" rel="stylesheet" /> \n`;
        });
        return cssPart;
    }

    public renderFooterScript() {
        let scriptPart = '{{source.globalJs | default("") | safe}}\n';
        this.options.js.forEach((path) => {
            scriptPart += `<script type="text/javascript" charset="UTF-8" src="${path}"></script> \n`;
        });
        return scriptPart;
    }

    public renderHeader() {
        return `
            ${super.renderHeader()}
            ${this.renderTitle()}
            ${this.renderMeta()}
            ${this.renderHeaderCss()}
            ${this.useSentry ? renderSentryReportWithVersion(this.data, this.SYSTEM) : ''}
            ${monitorPart(this.data)}
            ${bootPart(this.data)}
            ${es6ShimPart(this.data)}
        `;
    }

    public renderContent() {
        return '';
    }

    public renderFooter() {
        return `
            ${this.renderFooterScript()}
        `;
    }

    public render() {
        return super.render();
    }
}

export default StaticPageLayout;
